// src/components/Footer.tsx
import React from 'react';
import { Typography } from 'antd';

interface Props {
  darkMode: boolean;
}

const Footer: React.FC<Props> = ({ darkMode }) => {
  return (
    <div
      style={{
        textAlign: 'center',
        padding: '16px',
        borderTop: `1px solid ${darkMode ? '#333' : '#ddd'}`,
        fontSize: 14,
        backgroundColor: 'transparent',
      }}
    >
      <Typography.Text type="secondary">© 2025 Chumped</Typography.Text>
    </div>
  );
};

export default Footer;
